<template>
    <div>
        <div class="info title clearfix" :style="[ !img || img === '/static' ? {background: '#333'} : {background: 'url(' + img + ')'}]">
            <div class="wrapper clearfix">
                <div class="col-xs-120">
                    <h1>{{title}}</h1>
                </div>
            </div>
        </div>
        <div class="wrapper">
            <div class="col-xs-120 no-padding">
                <div class="info text clearfix">
                    <div class="wrapper">
                        <div class="sidebar_wrapper_info_main no-padding" v-if="type===1 && works">
                            <ul class="sidebar-cat">
                                <li v-for="(work, key) in works" :key="key" v-if="!(lang != 'ru' && work.id == 181)"><router-link :to="'/'+address+'/'+work.address+'/'">{{work.title}}</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-120 col-md-120 no-padding" v-if="type===2 && works">
                            <ul class="sidebar-cat">
                                <li v-for="(work,key) in works" :key="key"><router-link :to="'/'+parent.address+'/'+work.address+'/'">{{work.title}}</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-xs-120 text_raw_main_div">
                <v-runtime-template :template="text"/>
                </div>
                <reviews/>
            </div>
        </div>
        <articles/>
    </div>
</template>

<script>
import axios from '@/router/http'
import VRuntimeTemplate from 'v-runtime-template'
import fps from '@/components/blocks/FixPrices'
export default {
  name: 'Category',
  props: ['city', 'user', 'auth'],
  data: function () {
    return {
      type: null,
      address: null,
      lang: 'ru',
      text: null,
      title: null,
      img: null,
      works: [],
      parent: {},
      fixprice: []
    }
  },
  created () {
    axios.get('https://crm.v-avtoservice.com/list/site-get-category?link=' + window.location.pathname + '&city=' + this.city.id).then(response => {
      this.type = response.data.type
      this.address = response.data.address
      this.title = response.data.title
      this.img = response.data.img
      this.works = response.data.works
      this.parent = response.data.parent
      this.fixprice = response.data.fixprices
      this.text = '<div>' + response.data.text.replace(/{form_application}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_cat}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_shinomontag}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_avtourist}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_sravni_osago}/gi, '<osago-form/>').replace(/{form_sravni_kasko}/gi, '<kasko-form/>').replace(/{form_sokr}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_karta}/gi, '<texosmotr-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{/gi, '').replace(/}/gi, '').replace(new RegExp('../../../../frontend/public', 'g'), '/static').replace(new RegExp('../../../frontend/public', 'g'), '/static').replace(new RegExp('../../frontend/public', 'g'), '/static').replace(new RegExp('../frontend/public', 'g'), '/static').replace(new RegExp('frontend/public', 'g'), '/static').replace(new RegExp('../../../../uploads', 'g'), '/static/uploads').replace(new RegExp('../../../uploads', 'g'), '/static/uploads').replace(new RegExp('../../uploads', 'g'), '/static/uploads').replace(new RegExp('../uploads', 'g'), '/static/uploads').replace(new RegExp('uploads', 'g'), '/static/uploads').replace(new RegExp('<a', 'g'), '<router-link').replace(new RegExp('</a>', 'g'), '</router-link>').replace(new RegExp('href', 'g'), 'to') + '</div>'
    })
  },
  watch: {
    $route (to, from) {
      axios.get('https://crm.v-avtoservice.com/list/site-get-category?link=' + to.path + '&city=' + this.city.id).then(response => {
        this.type = response.data.type
        this.address = response.data.address
        this.title = response.data.title
        this.img = response.data.img
        this.works = response.data.works
        this.parent = response.data.parent
        this.fixprice = response.data.fixprices
        this.text = '<div>' + response.data.text.replace(/{form_application}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_cat}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_shinomontag}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_avtourist}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_sravni_osago}/gi, '<osago-form/>').replace(/{form_sravni_kasko}/gi, '<kasko-form/>').replace(/{form_sokr}/gi, '<fps :user.sync="user" :city.sync="city" :auth.sync="auth" :fixprice.sync="fixprice"></fps><index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_karta}/gi, '<texosmotr-form  :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{/gi, '').replace(/}/gi, '').replace(new RegExp('../../../../frontend/public', 'g'), '/static').replace(new RegExp('../../../frontend/public', 'g'), '/static').replace(new RegExp('../../frontend/public', 'g'), '/static').replace(new RegExp('../frontend/public', 'g'), '/static').replace(new RegExp('frontend/public', 'g'), '/static').replace(new RegExp('../../../../uploads', 'g'), '/static/uploads').replace(new RegExp('../../../uploads', 'g'), '/static/uploads').replace(new RegExp('../../uploads', 'g'), '/static/uploads').replace(new RegExp('../uploads', 'g'), '/static/uploads').replace(new RegExp('uploads', 'g'), '/static/uploads').replace(new RegExp('<a', 'g'), '<router-link').replace(new RegExp('</a>', 'g'), '</router-link>').replace(new RegExp('href', 'g'), 'to') + '</div>'
      })
    }
  },
  components: {
    VRuntimeTemplate,
    fps
  }
}
</script>

<style scoped>
    .sidebar-cat{list-style: none;background-color: #f5f5f5;padding: 0;}
    .sidebar-cat > li{padding: 7px 18px;border: 1px solid #e4e4e4;border-top: none;}
    .sidebar-cat > li:nth-child(1){border-top: 1px solid #e4e4e4;}
    .sidebar-cat > li >a:after{content: '';border: 6px solid transparent;border-left: 6px solid #4b80c6;margin: 0 0 -1px 5px;display: inline-block;}
    .sidebar-cat > li >a{color: #3a3a3a;}

    .sliks_conteiner{
        position: relative;
    }
    .big-arrow-left{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 50;
    }
    .big-arrow-right{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 50;
    }
    .sliks{
        margin: 0 60px;
    }
    sravni-widget {
        max-width: 100vw;
    }
    sravni-widget iframe {
        max-width: 100vw;
    }
</style>



// WEBPACK FOOTER //
// src/components/Category.vue